import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Dueños de cachorros nuevos (8 semanas a 6 meses) que están al borde del colapso.', 'Personas que trabajan desde casa y no pueden ser interrumpidas por ladridos constantes.', 'Familias que quieren proteger sus alfombras y muebles nuevos.', "Cualquiera que sienta que su cachorro 'tiene demasiada energía' y no sabe cómo canalizarla."];
  const isNotFor = ['Dueños de perros adultos con problemas de agresividad severa (esto es para cachorros).', 'Personas que buscan trucos de circo o entrenamiento de competencia.', 'Dueños que no están dispuestos a seguir un horario estricto por solo 48 horas.'];
  return <Section bg="cream" data-id="element-231">
      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-232">
        {/* Who it IS for */}
        <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-cream-dark" data-id="element-233">
          <h3 className="text-2xl font-bold text-navy mb-8 flex items-center gap-3" data-id="element-234">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-235">
              <Check className="w-6 h-6 text-green-600" data-id="element-236" />
            </div>
            Para quién es esto
          </h3>
          <ul className="space-y-5" data-id="element-237">
            {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-238">
                <Check className="w-5 h-5 text-green-500 shrink-0 mt-1" data-id="element-239" />
                <span className="text-navy/80 leading-relaxed" data-id="element-240">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Who it is NOT for */}
        <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-cream-dark opacity-90" data-id="element-241">
          <h3 className="text-2xl font-bold text-navy mb-8 flex items-center gap-3" data-id="element-242">
            <div className="w-10 h-10 rounded-full bg-softred/10 flex items-center justify-center" data-id="element-243">
              <X className="w-6 h-6 text-softred" data-id="element-244" />
            </div>
            Para quién NO es
          </h3>
          <ul className="space-y-5" data-id="element-245">
            {isNotFor.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-246">
                <X className="w-5 h-5 text-softred shrink-0 mt-1" data-id="element-247" />
                <span className="text-navy/70 leading-relaxed" data-id="element-248">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}